var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2033"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3201",
    d: "M6.49492 8.6985L6.86523 8.27264H15.6335V18.5607L15.2267 19.0286L14.8564 19.4545H6.08807V9.16638L6.49492 8.6985Z",
    stroke: "black",
    strokeWidth: 1.36364
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2829 5.87344L10.4493 5.682H18.2251V15.0333L17.9856 15.3087L17.8191 15.5002H17.4071V16.8638L18.4405 16.8638L19.0146 16.2035L19.5888 15.5432V5.682V4.31836H18.2251H9.82801L9.25385 4.97865L8.67969 5.63893V6.50018H10.0433V6.1489L10.2829 5.87344Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7fa055531c866be43d856c9b94b1c703.svg";
export { ForwardRef as ReactComponent };